import React from 'react';
import PureComponent from 'react-pure-render/component';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { loadEvent, setHeader } from 'actions';
import shallowEqual from 'react-pure-render/shallowEqual';
// import has from 'lodash/has';
import findIndex from 'lodash/findIndex';

import Loading from 'components/common/Loading';
import EventDetails from 'components/calendar/EventDetails';

class EventDetailPage extends PureComponent {
  static loadData(props) {
    const { event_id } = props;
    props.loadEvent(event_id);
  }

  static updateHeader(props) {
    const { event } = props;
    let rightAction;

    // if (has(event, 'metadata.actions.admin') && event.type) {
    //   if ((event.type.id === 1 || event.type.id === 6) && findIndex(event.metadata.actions.admin, check => check.text === 'Edit') !== -1) {
    //     rightAction = <Link to={`/calendar/edit/${event.id}`}>Edit</Link>;
    //   }
    // }

    props.setHeader('Event Details', (prevRoute) => {
      const { pathname } = prevRoute;

      if (!pathname) {
        return '/calendar';
      }
      else if (pathname.indexOf('add') === -1 && pathname.indexOf('edit') === -1) {
        return true;
      }
      return '/calendar';
    }, (prevRoute) => {
      const { pathname } = prevRoute;

      if (!pathname) {
        return '';
      }
      if (pathname.indexOf('page') !== -1 && pathname.indexOf('view') !== -1) {
        return 'Page';
      } else if (pathname.indexOf('schedule') !== -1 && pathname.indexOf('view') !== -1) {
        return 'Schedule';
      } else if (pathname.indexOf('calendar') !== -1 && pathname.indexOf('details') !== -1) {
        return 'Event';
      }
      return '';
    }, rightAction);
  }

  state = {}

  componentWillMount() {
    EventDetailPage.loadData(this.props);
    EventDetailPage.updateHeader(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.event_id && nextProps.event_id !== this.props.event_id) {
      EventDetailPage.loadData(nextProps);
    }

    if (nextProps.event && !shallowEqual(nextProps.event, this.props.event)) {
      EventDetailPage.updateHeader(nextProps);
    }
  }

  render() {
    const { event } = this.props;

    if (!event || event.isLoading) {
      return (
        <Loading withWrapper />
      );
    }

    if (event && !event.isLoading && !event.labels) {
      return (
        <div className="centered" style={{ minHeight: 200 }}>
          <Link to="/calendar">View Calendar</Link>
        </div>
      );
    }

    return (
      <EventDetails event={event} />
    );
  }
}

function mapStateToProps(state) {
  const { event_id } = state.router.params;
  const event = state.calendar.events.all[event_id];
  
  return {
    event_id,
    event,
  };
}

export default connect(mapStateToProps, {
  loadEvent,
  setHeader,
})(EventDetailPage);



// WEBPACK FOOTER //
// ./src/app/containers/EventDetailPage.js